import {
  TransferConfigsResponse,
  TransferConfig,
  TransferConfigResponse,
  SavedTransferConfig,
  PreviewRowsResponse,
  TabularPreviewRequest,
  TabularPreviewResponse,
  TabularSampleResponse,
} from '@ardoq/api-types/integrations';
import { Method, fetchJson, toRequestOptions, headers, fetchVoid } from './api';
import { ApiResponse } from './types';

const deleteConfiguration = async (id: string): ApiResponse<void> => {
  const request = new Request(
    `/api/integrations/tabular/mapping/${id}`,
    toRequestOptions(Method.DELETE, null)
  );
  return fetchVoid(request);
};

const updateConfiguration = async (config: SavedTransferConfig) => {
  const request = new Request(
    `/api/integrations/tabular/mapping/${config._id}`,
    toRequestOptions(Method.PUT, config)
  );
  return fetchJson<TransferConfigResponse>(request);
};

async function createConfiguration(config: TransferConfig) {
  const request = new Request(
    '/api/integrations/tabular/mapping',
    toRequestOptions(Method.POST, config)
  );
  return fetchJson<TransferConfigResponse>(request);
}

const fetchTransferConfigs = async () => {
  const request = new Request('/api/integrations/tabular/mapping', { headers });
  return fetchJson<TransferConfigsResponse>(request);
};

const fetchPreviewRows = async ({
  sourceId,
  tableId,
  startRow,
  rowCount,
}: {
  sourceId: string;
  tableId: string;
  startRow: number;
  rowCount: number;
}) => {
  const request = new Request(
    `/api/integrations/tabular/source/${sourceId}/table/${encodeURIComponent(tableId)}?startRow=${startRow}&numRows=${rowCount}`,
    { headers }
  );

  return fetchJson<PreviewRowsResponse>(request);
};

const fetchTabularPreview = async ({
  sourceId,
  payload: body,
}: {
  sourceId: string;
  payload: TabularPreviewRequest;
}) => {
  const request = new Request(
    `/api/integrations/tabular/source/${sourceId}/preview`,
    toRequestOptions(Method.POST, body)
  );
  return fetchJson<TabularPreviewResponse>(request);
};

const fetchTabularSample = async (sourceId: string) => {
  const request = new Request(
    `/api/integrations/tabular/source/${sourceId}/sample`,
    { headers }
  );
  return fetchJson<TabularSampleResponse>(request);
};

export const commonIntegrationApi = {
  deleteConfiguration,
  updateConfiguration,
  createConfiguration,
  fetchTransferConfigs,
  fetchPreviewRows,
  fetchTabularPreview,
  fetchTabularSample,
};
